@use '@/sass/variables';
@use '@/sass/utils/mixins';

.TimepointContainer {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 9999;

  .TimepointOverlay {
    position: absolute;
    background-color: variables.$white;

    .TimepointComponent {
      display: flex;
      flex-direction: column;
      border: #ccc solid 1px;
      width: 100%;
      box-sizing: border-box;

      .Input {
        border: none;
        outline: none;
        margin: 0;
        box-sizing: border-box;

        &:focus {
          border: none;
          outline: none;
          box-shadow: none;
        }

        &:active {
          border: none;
          outline: none;
          box-shadow: none;
        }
      }
    }
  }
}

.Chips {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  font-size: variables.$font-size-8;
  width: 100%;
  box-sizing: border-box;
  padding: 0 variables.$spacing-extra-small;

  .Chip {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: variables.$moon-gray;
    border-radius: variables.$border-radius-2;
    padding: variables.$spacing-extra-small variables.$spacing-extra-small;
    margin: variables.$spacing-extra-small variables.$spacing-extra-small variables.$spacing-extra-small 0;

    .Value {
      color: variables.$near-black;
    }

    .Remove {
      color: variables.$dark-gray;
      cursor: pointer;
      font-weight: bold;
    }
  }
}
